import {Component, Input} from "@angular/core";
import {Stock} from "../../../shared/view-model/stock";
import {StockService} from "../../services/stock.service";
import {StockInput} from "../../services/stock-input.type";

@Component({
  selector: 'vb-stock-limits',
  templateUrl: './stock-limits.component.html',
  styleUrls: ['./stock-limits.component.css']
})
export class StockLimitsComponent {

  private _stock: Stock = <Stock>{};
  private origMinStock: number;
  private origReportStock: number;
  private origShallStock: number;

  @Input()
  set stock(stock: Stock) {
    this._stock = stock;
    this.origMinStock = this._stock.min_stock;
    this.origReportStock = this._stock.report_stock;
    this.origShallStock = this._stock.shall_stock;
  }

  active = true;

  get stock(): Stock {
    return this._stock;
  }


  constructor(private stockService: StockService) {

  }

  onSubmit() {

    let stockInput: StockInput = {
      cuid: this.stock.cuid,
      min_stock: this.stock.min_stock,
      report_stock: this.stock.report_stock,
      shall_stock: this.stock.shall_stock
    };

    this.stockService.updateStock(stockInput);

  }

  resetLimits() {
    this.stock.min_stock = this.origMinStock;
    this.stock.report_stock = this.origReportStock;
    this.stock.shall_stock = this.origShallStock;
    this.active = false;
    setTimeout(() => this.active = true, 0);
  }

  /**
   * Defines the CSS styles for highlighting the stock
   * @param stock the stock to format
   * @returns {{bg-warning: boolean, bg-danger: boolean, bg-success: boolean}} a ngClass array with the styles
   */
  setClasses(stock: Stock) {
    let cssClasses = {};
    return cssClasses;
  }

}



// WEBPACK FOOTER //
// ./src/app/store-management/stock/stock-limits/stock-limits.component.ts